import React, { useState, useEffect } from "react";
import FormSectionNew from "components/sales/formSection/formSectionNew";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import './mrfStatus.css'
export const MrfStatus = ({ handleValue, match, data = null }) => {
  const onGenerateMrf = (flag) => {
    handleValue(flag);
  };
  return (
    <FormSectionNew title={localization.mrf} status={data && data.status_name}>
      {(data && Object.keys(data).length === 0) || data === null  || data.status !== 1 && data.status !== 2 && data.status !== 3 ? (
        <div className="form-group form-btn">
          <Button
            onClick={() => onGenerateMrf(false)}
            className="btn btn-transparent"
          >
            {localization.generateMRF}
          </Button>
        </div>
      ) : (
        <div className="details-listing">
          <DivLayout
            heading={localization.mrfRaisedDate}
            data={data.created_at && data.created_at.slice(0, 10)}
          />
          <DivLayout
            heading={localization.raisedBy}
            data={data.raised_by && data.raised_by}
          />
          <div className="form-group form-btn form_flex">
            <Button
              onClick={() => onGenerateMrf(true)}
              className="btn btn-transparent1 btn-clr New-btn-Al"
            >
              <b  className="transparent11">{localization.viewMRF}</b>
            </Button>
          </div>
        </div>
      )}
    </FormSectionNew>
  );
};
